export default __webpack_public_path__ + "static/media/es-ga.3ee91d1e.svg";